import React, {useContext, useEffect} from 'react';
import useStyles from "./styles";
import { FormGroup, FormHelperText, Grid, InputBase } from "@material-ui/core";
import Index from "../StripeInput";
import PostalCode from "../PostalCode";
import { CARD_OPTIONS } from "../../constants";
import { useTranslation } from 'react-i18next';
import stripErrors from '../../utils/stripErrors';
import {CheckoutComFramesReady} from "../../App";
import {CardNumber, Cvv, ExpiryDate} from "frames-react";

const Card = ({ formik }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  // const elements = useElements();
  const checkoutComFramesReady = useContext(CheckoutComFramesReady);

  useEffect(() => {
    if (checkoutComFramesReady) {
      checkoutComFramesReady(true);
    }
  }, []);

  const cardHandler = e => {
    const { element, ...obj } = e
    formik.setFieldValue(element, { ...obj });
    formik.setFieldError(element, obj.error);
    // if (e.complete) {
    //   if (element === "cardNumber") {
    //     elements?.getElement(CardExpiryElement)?.focus();
    //   }
    //   if (element === "cardExpiry") {
    //     elements?.getElement(CardCvcElement)?.focus();
    //   }
    //   if (element === "cardCvc") {
    //     document.getElementsByName('cardName')[0].focus()
    //   }
    // }
  }
  return (<div className={classes.cardWrapper}>
    <FormGroup className={classes.cardForm}>
      <p className={`${classes.cardText} input_label_text`}>{t('Card_number')}</p>
      <InputBase
        error={!!(formik.values.cardNumber?.error)}
        label={t('Card_Number')}
        className={classes.inputBase}
        name={"cardNumber"}
        onChange={cardHandler}
        value={formik.values.cardNumber}
        variant="outlined"
        required
        fullWidth
        inputComponent={Index}
        inputProps={{
          component: CardNumber,
          options: { ...CARD_OPTIONS }
        }}
      />
      <FormHelperText className='error_text' error>{stripErrors(formik.values.cardNumber?.error?.message)}</FormHelperText>
    </FormGroup>
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <FormGroup className={classes.cardForm}>
          <p className={`${classes.cardText} input_label_text`}>{t('Expiry_date')}</p>
          <InputBase
            error={!!(formik.values.cardExpiry?.error)}
            label={t('Expiry_date')}
            placeholder={t('card_expiry_placeholder')}
            name="cardExpiry"
            className={classes.inputBase}
            variant="outlined"
            required
            fullWidth
            onChange={cardHandler}
            value={formik.values.cardExpiry}
            inputComponent={Index}
            inputProps={{
              component: ExpiryDate,
              options: CARD_OPTIONS
            }}
          />
          <FormHelperText className='error_text' error>{stripErrors(formik.values.cardExpiry?.error?.message)}</FormHelperText>
        </FormGroup>
      </Grid>
      <Grid item xs={6}>
        <FormGroup className={classes.cardForm}>
          <p className={`${classes.cardText} input_label_text`}>{t('CVC')}</p>
          <InputBase
            error={!!(formik.values.cardCvc?.error)}
            label="CVC"
            className={classes.inputBase}
            name="cardCvc"
            variant="outlined"
            required
            fullWidth
            onChange={cardHandler}
            value={formik.values.cardCvc}
            inputComponent={Index}
            inputProps={{
              component: Cvv,
              options: { ...CARD_OPTIONS, showIcon: true }
            }}
          />
          <FormHelperText className='error_text' error>{formik.values.cardCvc?.error?.message}</FormHelperText>
        </FormGroup>
      </Grid>
    </Grid>
    <FormGroup className={classes.cardForm}>
      <p className={`${classes.cardText} input_label_text`}>{t('Name_on_Card')}</p>
      <InputBase
        error={!!(formik.errors?.cardName && formik.touched?.cardName)}
        placeholder={t('Name_on_Card')}
        label={t('Name_on_Card')}
        name="cardName"
        value={formik.values.cardName?.toUpperCase()}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        variant="outlined"
        required
        fullWidth
        inputProps={{
          maxLength: 100,
        }}
      />
      {
        formik.errors?.cardName && formik.touched?.cardName && (
          <FormHelperText className='error_text' error>{formik.errors?.cardName}</FormHelperText>
        )
      }
    </FormGroup>
    <PostalCode formik={formik} className={`${classes.cardForm} input_label_text`} />
  </div>)
}

export default Card;
